// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
}

.spinner span {
  font-size: 2rem;
  /* animation: fade 1s linear 0s infinite; */
  padding-right: 1rem;
}

.half-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #307544;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.5s linear 0s infinite;
}

.completed {
  font-size: 2rem;
  color: #30613f;
  animation: bigger 1s linear;
}

@keyframes bigger {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(2);
  }
}

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/LoadingScreen/LoadingScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n}\n\n.spinner span {\n  font-size: 2rem;\n  /* animation: fade 1s linear 0s infinite; */\n  padding-right: 1rem;\n}\n\n.half-spinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid #307544;\n  border-top: 3px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.5s linear 0s infinite;\n}\n\n.completed {\n  font-size: 2rem;\n  color: #30613f;\n  animation: bigger 1s linear;\n}\n\n@keyframes bigger {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(2);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
